import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LinksPageComponent } from './links-page/links-page.component'
import { ProjectDashboardComponent } from './project-dashboard/project-dashboard.component'
import { AdminPageComponent } from './admin-page/admin-page.component'
import { ProjectSummaryComponent } from './project-summary/project-summary.component'
import { TopicSummaryComponent } from './topic-summary/topic-summary.component'
import { ProjectDbRecordsComponent } from './project-db-records/project-db-records.component';
import { EditDbRecordBoxComponent } from './edit-db-record-box/edit-db-record-box.component';

const appRoutes: Routes = [
  {
    path: 'projects',
    component: ProjectDashboardComponent,
  },
  {
    path: 'project/:id',
    component: ProjectSummaryComponent,
  },
  {
    path: 'project/:id/dbRecords',
    component: ProjectDbRecordsComponent,
  },
  {
    path: 'topic/:id',
    component: TopicSummaryComponent,
  },
  {
    path: 'links',
    component: LinksPageComponent,
  },
  {
    path: 'admin/:tp',
    component: AdminPageComponent,
  },
  {
    path: 'admin/editDbRecord/:id',
    component: EditDbRecordBoxComponent,
  },
  {
    path: 'admin/:tp/:id',
    component: AdminPageComponent,
  },
  {
    path: '**',
    redirectTo: 'projects',
  },
];
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts